import React, { useState, useEffect, useRef } from "react";
import { X, Play } from "lucide-react";
import PageHero from "../components/PageHero";
import FadeIn from "../components/FadeIn";
import { GALLERY } from "../mock";
import useSEO from "../hooks/useSEO";

const Gallery = () => {
  useSEO({
    title: "Gallery",
    description: "Photo and video gallery showing Prime Trade L.L.C — FZ operations: ports, refineries, warehouses and global logistics.",
  });
  const [active, setActive] = useState(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const videoEl = videoRef.current;
    if (videoEl && active?.type === "video") {
      videoEl.muted = true;
      videoEl.defaultMuted = true;
      videoEl.play().catch((err) => {
        console.error("Video autoplay failed:", err);
      });
    }
  }, [active]);
  return (
    <main>
      <PageHero title="Gallery" eyebrow="Our work" breadcrumbs={[{ label: "Gallery" }]} />
      <section className="pt-section">
        <div className="max-w-[1320px] mx-auto px-6">
          <FadeIn>
            <div className="max-w-2xl mb-12">
              <div className="pt-eyebrow">Snapshots</div>
              <h2 className="pt-h2">From ports to refineries</h2>
              <div className="pt-divider" />
              <p className="text-[15px] text-[#4a4a4a] leading-relaxed">A visual look at the operations, partners and people that power our supply chain.</p>
            </div>
          </FadeIn>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {GALLERY.map((item, i) => (
              <FadeIn key={i} delay={i * 40}>
                <button onClick={() => setActive(item)} className="pt-gallery-item w-full block relative">
                  <img src={item.type === "video" ? item.thumb : item.src} alt={item.title || `Gallery ${i + 1}`} />
                  {item.type === "video" && (
                    <span className="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
                      <span className="w-16 h-16 rounded-full bg-[#c9a961] flex items-center justify-center shadow-lg">
                        <Play size={24} className="text-[#16223a] ml-1" fill="#16223a" />
                      </span>
                    </span>
                  )}
                </button>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div
          className="fixed inset-0 bg-black/85 z-[100] flex items-center justify-center p-4"
          onClick={() => setActive(null)}
        >
          <button
            className="absolute top-6 right-6 text-white hover:text-[#d4b673] z-10"
            onClick={() => setActive(null)}
            aria-label="Close"
          >
            <X size={32} />
          </button>
          <div onClick={(e) => e.stopPropagation()} className="max-h-[88vh] max-w-[92vw] flex items-center justify-center">
            {active.type === "video" ? (
              <video
                ref={videoRef}
                key={active.src}
                src={active.src}
                controls
                autoPlay
                muted
                playsInline
                preload="auto"
                className="max-h-[88vh] max-w-[92vw]"
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <img src={active.src} alt="Gallery preview" className="max-h-[88vh] max-w-[92vw] object-contain" />
            )}
          </div>
        </div>
      )}
    </main>
  );
};

export default Gallery;
